export const translations = {
    it: {
        // Anniversary Animation
        anniversary: {
            since: "DAL 1986",
            years: "ANNI DI ECCELLENZA",
            motto: "Illuminiamo il futuro",
            skip: "SALTA →"
        },

        // Hero Section
        hero: {
            title: "Ellegi",
            subtitle: "Specialisti in Illuminotecnica",
            tagline: "Dal 1986 illuminiamo i tuoi spazi con soluzioni innovative e professionali",
            cta: "Scopri di più"
        },

        // Menu
        menu: {
            home: "Home",
            about: "Chi Siamo",
            projects: "Progetti",
            news: "News",
            collaborations: "Collaborazioni",
            files: "Download",
            contacts: "Contatti",
            followUs: "Follow Us",
            contactUs: "Contattaci",
            brandDesc: "Eccellenza creativa e pensiero strategico. Illuminiamo il tuo marchio con soluzioni su misura."
        },

        // Services
        services: {
            title: "SERVIZI",
            office: "Illuminazione Uffici",
            retail: "Illuminazione Retail",
            hospitality: "Illuminazione Hotel & Ristoranti",
            industrial: "Illuminazione Industriale",
            consulting: "Consulenza Tecnica"
        },

        // Contact Info
        contact: {
            title: "CONTATTI",
            location: "Milano • Lombardia • Italia"
        },

        // Footer
        footer: {
            copyright: "© 2026 ELLEGI",
            tagline: "Illuminazione Professionale dal 1986",
            companyDesc: "Dal 1986 illuminiamo i tuoi spazi con soluzioni innovative e professionali. Specializzati in illuminazione tecnica per uffici, retail, hospitality e industria.",
            companyTagline: "Illuminazione Professionale - Esperienza, qualità e innovazione al servizio della luce.",
            contactsTitle: "Contatti",
            quickLinksTitle: "Link Rapidi",
            quickAbout: "Chi Siamo",
            quickProjects: "Progetti",
            quickNews: "News",
            quickCollaborations: "Collaborazioni",
            quickInfo: "Informazioni",
            quickContacts: "Contatti",
            allRights: "© 2026 ELLEGI S.r.l. - Tutti i diritti riservati",
            vatInfo: "P.IVA: 08437620159 - Dal 1986 nel settore illuminotecnico",
            termsOfService: "Termini di Servizio"
        },

        // About Section
        about: {
            title: "Chi Siamo",
            yearsOfLight: "anni di luce",
            tagline: "…Your Partner in light",
            intro: "è un team di professionisti che opera da",
            intro2: "anni nel settore illuminotecnico proponendo soluzioni innovative ed efficienti, affiancando professionisti e operatori del settore in tutta la fase di progettazione.",
            partnership: "Partnership d'Eccellenza",
            partnershipDesc: "Collaboriamo con partner di assoluto prestigio, pionieri nella produzione di sistemi di illuminazione all'avanguardia e, attraverso un rapporto diretto e costante con queste aziende, definiamo ogni aspetto tecnico-commerciale di un progetto.",
            solutions: "Soluzioni Su Misura",
            solutionsDesc: "Garantiamo soluzioni tailor-made, innovative, smart ed efficienti, che strizzano l'occhio all'ecosostenibilità, senza tralasciare l'impatto visivo e la dimensione architetturale.",
            versatility: "Versatilità e Competenza",
            versatilityDesc: "Grazie all'ampia gamma di proposte possibili, sia per l'outdoor sia per l'indoor, siamo in grado di rispondere a qualunque richiesta spaziando in tutti i settori, dal retail agli uffici, dall'industria all'hotellerie, fino all'intrattenimento e all'health care.",
            ourValues: "I NOSTRI VALORI",
            ourSkills: "LE NOSTRE COMPETENZE",
            ourSolutions: "LE NOSTRE SOLUZIONI PER",
            indoorSpaces: "SPAZI INTERNI",
            outdoorSpaces: "SPAZI ESTERNI",
            showMore: "Scopri di più",
            showLess: "Mostra meno",
            lightingFuture: "Illuminiamo il Futuro Insieme",
            lightingFutureDesc: "Con 40 anni di esperienza continuiamo a portare luce e innovazione in ogni progetto, trasformando spazi in esperienze luminose indimenticabili.",
            yearsExperience: "Anni di Esperienza",
            projectsCompleted: "Progetti Realizzati",
            passionDedication: "Passione e Dedizione",
            lightQuote: "La luce non è solo illuminazione, è emozione, è atmosfera, è vita.",
            // Values accordion
            valInnovazioneTitle: "INNOVAZIONE",
            valInnovazioneShort: "Partner d'eccellenza nella produzione di sistemi all'avanguardia",
            valInnovazioneFull: "Lavoriamo con partner d'eccellenza, pionieri nella produzione di sistemi di illuminazione all'avanguardia. La nostra rete di collaborazioni ci permette di offrire soluzioni tecnologicamente avanzate e sempre al passo con le ultime innovazioni del settore.",
            valEsperienzaTitle: "ESPERIENZA",
            valEsperienzaShort: "40 anni di collaborazione con professionisti specializzati",
            valEsperienzaFull: "Collaboriamo da 40 anni con progettisti e interlocutori specializzati, acquisendo un patrimonio di conoscenze e competenze che ci permette di affrontare ogni progetto con sicurezza e dedizione. Tra i partner con i quali abbiamo cooperato in passato figurano Zumtobel, Reggiani, Bega, Limburg e Osram.",
            valSostenibilitaTitle: "SOSTENIBILITÀ",
            valSostenibilitaShort: "Soluzioni intelligenti a ridotto impatto energetico",
            valSostenibilitaFull: "Proponiamo soluzioni illuminotecniche intelligenti e a ridotto impatto energetico, contribuendo attivamente alla sostenibilità ambientale. Ogni nostro progetto è studiato per massimizzare l'efficienza energetica senza compromettere la qualità della luce.",
            valAffidabilitaTitle: "AFFIDABILITÀ",
            valAffidabilitaShort: "Esperienza comprovata in tutti i settori",
            valAffidabilitaFull: "Il nostro team di professionisti vanta comprovate esperienze nella progettazione e distribuzione nei settori retail, uffici, industria, hotellerie, intrattenimento ed health care. La nostra affidabilità è testimoniata dai numerosi progetti realizzati con successo.",
            // Skills cards
            skill1Title: "Affianchiamo",
            skill1Desc: "i professionisti e gli operatori nella fase di progettazione",
            skill2Title: "Definiamo",
            skill2Desc: "ogni aspetto tecnico-commerciale",
            skill3Title: "Proponiamo",
            skill3Desc: "soluzioni tailor-made",
            skill4Title: "Verifichiamo",
            skill4Desc: "soluzioni di efficientamento ed ecosostenibilità",
            // Indoor spaces
            indoor1: "Uffici & Industrie",
            indoor2: "Hotel & Ristoranti",
            indoor3: "Negozi & Showroom",
            indoor4: "Data Center & Logistica",
            indoor5: "Residenze Private",
            indoor6: "Sale Riunioni & Conferenze",
            indoor7: "Health & Care",
            indoor8: "Piscine & Palestre",
            indoor9: "Chiese & Musei",
            // Outdoor spaces
            outdoor1: "Aree Verdi",
            outdoor2: "Parchi Naturali",
            outdoor3: "Giardini & Aree Archeologiche",
            outdoor4: "Viabilità & Piste Ciclabili",
            outdoor5: "Centri Sportivi",
            outdoor6: "Parcheggi",
            outdoor7: "Aeroporti & Stazioni"
        },

        // Projects Section
        projects: {
            title: "PROGETTI",
            subtitle: "Esplora i nostri progetti per categoria",
            viewMore: "Visualizza",
            projectsCount: "progetti",
            // Category titles
            catOffices: "Uffici",
            catOfficesSub: "Uffici",
            catRetail: "Negozi & Retail",
            catRetailSub: "Negozi e Retail",
            catOutdoor: "Spazi Esterni",
            catOutdoorSub: "Outdoor",
            catInteriors: "Spazi Interni",
            catInteriorsSub: "Interni",
            catIndustry: "Industria",
            catIndustrySub: "Industria"
        },

        // News Section
        news: {
            title: "NEWS",
            discoverMore: "Scopri di più",
            infoTitle: "Informazioni",
            infoText: "Per maggiori informazioni o richiedere una consulenza:",
            featured: "IN EVIDENZA"
        },

        // Collaborations Section
        collaborations: {
            title: "COLLABORAZIONI",
            sectionTitle: "Collaborazioni",
            intro: "Collaboriamo da 40 anni con progettisti e interlocutori specializzati, acquisendo un patrimonio di conoscenze e competenze che ci permette di affrontare ogni progetto con sicurezza e dedizione. Tra i partner con i quali abbiamo cooperato in passato figurano Zumtobel, Reggiani, Bega, Limburg e Osram.",
            ourPartners: "I Nostri Partner",
            visitSite: "Visita il sito",
            interestedTitle: "Interessato a collaborare con noi?",
            interestedDesc: "Contattaci!",
            discoverMore: "Scopri di più",
            auto: "Auto",
            manual: "Manual",
            // Partner descriptions
            partnerIntraDesc: "Apparecchi di illuminazione indoor intelligenti, creativi e dal design senza tempo",
            partnerCariboniDesc: "Leader dell'illuminazione outdoor con prodotti 100% made in Italy",
            partnerRidiDesc: "Apparecchi e sistemi di illuminazione professionale per interni",
            partnerWielandDesc: "Soluzioni elettriche e di automazione, con focus sulla tecnologia di installazione plug & play",
            partnerLeitnerDesc: "Apparecchi di illuminazione ad energia solare d'accento per esterni",
            partnerTwinklyDesc: "Smart decorative lighting"
        },

        // Files Section
        files: {
            title: "DOWNLOAD",
            subtitle: "Scarica i nostri documenti aziendali, cataloghi prodotti, certificazioni e materiale informativo",
            all: "Tutti",
            download: "Scarica",
            goToSite: "Vai al sito",
            restricted: "Riservato",
            needDocsTitle: "Hai bisogno di documenti specifici?",
            needDocsDesc: "Non trovi quello che cerchi? Contattaci e ti forniremo tutta la documentazione di cui hai bisogno.",
            contactUs: "Contattaci",
            // File data
            filePres: "Presentazione Ellegi",
            filePresDesc: "Presentazione completa Ellegi",
            filePresOutdoor: "Presentazione Ellegi - Proposte Outdoor",
            filePresOutdoorDesc: "Presentazione Ellegi con proposte outdoor",
            fileCollImg: "Collaborazioni Ellegi - Completa con immagini",
            fileCollImgDesc: "Collaborazioni Ellegi con immagini",
            fileCollNoImg: "Collaborazioni Ellegi - Completa senza immagini",
            fileCollNoImgDesc: "Collaborazioni Ellegi senza immagini",
            fileCatCariboni: "Catalogo Cariboni Group",
            fileCatCariboniDesc: "Documentazione prodotti Cariboni",
            fileCatRidi: "Catalogo RIDI Italia",
            fileCatRidiDesc: "Soluzioni illuminotecniche RIDI",
            fileCatIntra: "Catalogo Intra Lighting",
            fileCatIntraDesc: "Prodotti Intra Lighting",
            fileCatLeitner: "Catalogo Leitner Energy",
            fileCatLeitnerDesc: "Soluzioni Leitner Energy",
            fileCatTwinkly: "Area Download Twinkly",
            fileCatTwinklyDesc: "Smart decorative lighting",
            fileCatWieland: "Catalogo Wieland Electric",
            fileCatWielandDesc: "Soluzioni Wieland Electric"
        },

        // Contacts Section
        contacts: {
            title: "CONTATTI",
            ourTeam: "Il Nostro Team",
            headquarters: "Sede legale e AREA CENTRO",
            phone: "Telefono",
            email: "Email",
            contactUsTitle: "Contattaci",
            teamTitle: "Il Nostro Team",
            formPrivacyAlert: "Devi accettare la Privacy Policy per continuare.",
            mobLabel: "Mob.",
            // Team member descriptions
            teamClaudioDesc: "Fondatore di ELLEGI, opera nel settore illuminotecnico dal 1986. Oggi è responsabile e coordinatore dell'agenzia.",
            teamStefanoDesc: "Opera nell'area di Milano e coordina le aree est e ovest.",
            teamAchilleDesc: "Consulente tecnico commerciale con esperienze nella gestione degli spazi di lavoro.",
            teamGabrieleDesc: "Consulente tecnico commerciale con esperienza nel settore.",
            teamSilviaDesc: "Responsabile marketing & comunicazione con esperienza nel settore.",
            teamMariaTeresaDesc: "Responsabile dell'amministrazione e della gestione delle finanze della società.",
            teamStefaniaDesc: "Responsabile della gestione degli ordini e dell'assistenza al cliente.",
            // Professions
            prof1: "Commerciante", prof2: "Consulente", prof3: "Docente", prof4: "Elettricista",
            prof5: "Giornalista", prof6: "Imprenditore", prof7: "Installatore",
            prof8: "Libero Professionista", prof9: "Lighting Designer",
            prof10: "Progettista", prof11: "Project Manager",
            // Request types
            req1: "Richiesta catalogo", req2: "Richiesta contatto",
            req3: "Richiesta info distributore", req4: "Supporto tecnico", req5: "Altro",
            formCompany: "Azienda",
            formName: "Nome e Cognome",
            formProfession: "Professione",
            formEmail: "Email",
            formPhone: "Telefono",
            formAddress: "Indirizzo",
            formCity: "Città",
            formZip: "CAP",
            formProvince: "Provincia",
            formCountry: "Nazione",
            formRequestType: "Tipo di richiesta",
            formMessage: "Messaggio",
            formPrivacy: "Accetto la Privacy Policy e autorizzo il trattamento dei miei dati personali secondo quanto previsto dal Regolamento UE 2016/679 (GDPR).",
            formSubmit: "Invia Richiesta",
            formRequired: "Campi obbligatori. Le tue informazioni saranno trattate nel rispetto della privacy.",
            successTitle: "Richiesta Inviata con Successo!",
            successMessage: "Grazie per le informazioni dettagliate fornite.",
            successFollowUp: "Il nostro team ti contatterà entro 24 ore per discutere il tuo progetto.",
            selectProfession: "Seleziona una professione",
            selectCountry: "Seleziona una nazione",
            selectRequestType: "Seleziona il tipo di richiesta",
            messagePlaceholder: "Inserisci qui il tuo messaggio...",
            companyPlaceholder: "Nome della tua azienda",
            namePlaceholder: "Il tuo nome e cognome",
            emailPlaceholder: "La tua email (es. nome@esempio.com)",
            phonePlaceholder: "Il tuo numero di telefono",
            addressPlaceholder: "Il tuo indirizzo",
            cityPlaceholder: "La tua città",
            zipPlaceholder: "Codice postale",
            provincePlaceholder: "La tua provincia"
        }
    },

    en: {
        // Anniversary Animation
        anniversary: {
            since: "SINCE 1986",
            years: "YEARS OF EXCELLENCE",
            motto: "Lighting the future",
            skip: "SKIP →"
        },

        // Hero Section
        hero: {
            title: "Ellegi",
            subtitle: "Lighting Specialists",
            tagline: "Since 1986 we have been lighting your spaces with innovative and professional solutions",
            cta: "Discover more"
        },

        // Menu
        menu: {
            home: "Home",
            about: "About Us",
            projects: "Projects",
            news: "News",
            collaborations: "Collaborations",
            files: "Downloads",
            contacts: "Contacts",
            followUs: "Follow Us",
            contactUs: "Contact Us",
            brandDesc: "Creative excellence and strategic thinking. We light your brand with tailored solutions."
        },

        // Services
        services: {
            title: "SERVICES",
            office: "Office Lighting",
            retail: "Retail Lighting",
            hospitality: "Hotel & Restaurant Lighting",
            industrial: "Industrial Lighting",
            consulting: "Technical Consulting"
        },

        // Contact Info
        contact: {
            title: "CONTACTS",
            location: "Milan • Lombardy • Italy"
        },

        // Footer
        footer: {
            copyright: "© 2026 ELLEGI",
            tagline: "Professional Lighting since 1986",
            companyDesc: "Since 1986 we have been lighting your spaces with innovative and professional solutions. Specialized in technical lighting for offices, retail, hospitality and industry.",
            companyTagline: "Professional Lighting - Experience, quality and innovation at the service of light.",
            contactsTitle: "Contacts",
            quickLinksTitle: "Quick Links",
            quickAbout: "About Us",
            quickProjects: "Projects",
            quickNews: "News",
            quickCollaborations: "Collaborations",
            quickInfo: "Information",
            quickContacts: "Contacts",
            allRights: "© 2026 ELLEGI S.r.l. - All rights reserved",
            vatInfo: "P.IVA: 08437620159 - Since 1986 in the lighting industry",
            termsOfService: "Terms of Service"
        },

        // About Section
        about: {
            title: "About Us",
            yearsOfLight: "years of light",
            tagline: "…Your Partner in light",
            intro: "is a team of professionals operating for",
            intro2: "years in the lighting sector, offering innovative and efficient solutions, supporting professionals and industry operators throughout the design phase.",
            partnership: "Partnerships of Excellence",
            partnershipDesc: "We collaborate with partners of absolute prestige, pioneers in the production of cutting-edge lighting systems and, through a direct and constant relationship with these companies, we define every technical-commercial aspect of a project.",
            solutions: "Customized Solutions",
            solutionsDesc: "We guarantee tailor-made, innovative, smart and efficient solutions that are environmentally friendly, without neglecting the visual impact and architectural dimension.",
            versatility: "Versatility and Expertise",
            versatilityDesc: "Thanks to the wide range of possible proposals, both for outdoor and indoor, we are able to respond to any request spanning all sectors, from retail to offices, from industry to hospitality, to entertainment and health care.",
            ourValues: "OUR VALUES",
            ourSkills: "OUR SKILLS",
            ourSolutions: "OUR SOLUTIONS FOR",
            indoorSpaces: "INDOOR SPACES",
            outdoorSpaces: "OUTDOOR SPACES",
            showMore: "Discover more",
            showLess: "Show less",
            lightingFuture: "Lighting the Future Together",
            lightingFutureDesc: "With 40 years of experience, we continue to bring light and innovation to every project, transforming spaces into unforgettable luminous experiences.",
            yearsExperience: "Years of Experience",
            projectsCompleted: "Projects Completed",
            passionDedication: "Passion and Dedication",
            lightQuote: "Light is not just illumination, it is emotion, it is atmosphere, it is life.",
            // Values accordion
            valInnovazioneTitle: "INNOVATION",
            valInnovazioneShort: "Excellence partners in producing cutting-edge systems",
            valInnovazioneFull: "We work with partners of excellence, pioneers in the production of cutting-edge lighting systems. Our collaboration network allows us to offer technologically advanced solutions that are always in step with the latest sector innovations.",
            valEsperienzaTitle: "EXPERIENCE",
            valEsperienzaShort: "40 years of collaboration with specialised professionals",
            valEsperienzaFull: "We have been collaborating for 40 years with designers and specialised partners, acquiring a wealth of knowledge and skills. Among partners with whom we have cooperated in the past: Zumtobel, Reggiani, Bega, Limburg and Osram.",
            valSostenibilitaTitle: "SUSTAINABILITY",
            valSostenibilitaShort: "Smart solutions with low energy impact",
            valSostenibilitaFull: "We offer intelligent lighting solutions with low energy impact, actively contributing to environmental sustainability. Every project is designed to maximise energy efficiency without compromising light quality.",
            valAffidabilitaTitle: "RELIABILITY",
            valAffidabilitaShort: "Proven expertise across all sectors",
            valAffidabilitaFull: "Our team of professionals has proven experience in design and distribution in the retail, office, industry, hospitality, entertainment and health care sectors. Our reliability is demonstrated by the many projects successfully completed.",
            // Skills cards
            skill1Title: "We support",
            skill1Desc: "professionals and operators during the design phase",
            skill2Title: "We define",
            skill2Desc: "every technical and commercial aspect",
            skill3Title: "We propose",
            skill3Desc: "tailor-made solutions",
            skill4Title: "We verify",
            skill4Desc: "energy efficiency and eco-sustainability solutions",
            // Indoor spaces
            indoor1: "Offices & Industries",
            indoor2: "Hotels & Restaurants",
            indoor3: "Shops & Showrooms",
            indoor4: "Data Centers & Logistics",
            indoor5: "Private Residences",
            indoor6: "Meeting & Conference Rooms",
            indoor7: "Health & Care",
            indoor8: "Swimming Pools & Gyms",
            indoor9: "Churches & Museums",
            // Outdoor spaces
            outdoor1: "Green Areas",
            outdoor2: "Natural Parks",
            outdoor3: "Gardens & Archaeological Sites",
            outdoor4: "Roads & Cycle Paths",
            outdoor5: "Sports Centres",
            outdoor6: "Car Parks",
            outdoor7: "Airports & Stations"
        },

        // Projects Section
        projects: {
            title: "PROJECTS",
            subtitle: "Explore our projects by category",
            viewMore: "View",
            projectsCount: "projects",
            // Category titles
            catOffices: "OFFICES",
            catOfficesSub: "Offices",
            catRetail: "Shops & Retail",
            catRetailSub: "Shops & Retail Stores",
            catOutdoor: "Outdoor Spaces",
            catOutdoorSub: "Outdoor",
            catInteriors: "Interior Spaces",
            catInteriorsSub: "Interiors",
            catIndustry: "Industry",
            catIndustrySub: "Industry"
        },

        // News Section
        news: {
            title: "NEWS",
            discoverMore: "Discover more",
            infoTitle: "Information",
            infoText: "For more information or to request a consultation:",
            featured: "FEATURED"
        },

        // Collaborations Section
        collaborations: {
            title: "COLLABORATIONS",
            sectionTitle: "Collaborations",
            intro: "We have been collaborating for 40 years with designers and specialized partners, acquiring a wealth of knowledge and skills that allows us to tackle every project with confidence and dedication. Among the partners with whom we have cooperated in the past are Zumtobel, Reggiani, Bega, Limburg and Osram.",
            ourPartners: "Our Partners",
            visitSite: "Visit website",
            interestedTitle: "Interested in collaborating with us?",
            interestedDesc: "Contact us!",
            discoverMore: "Discover more",
            auto: "Auto",
            manual: "Manual",
            // Partner descriptions
            partnerIntraDesc: "Intelligent, creative indoor lighting fixtures with timeless design",
            partnerCariboniDesc: "Leader in outdoor lighting with 100% made in Italy products",
            partnerRidiDesc: "Professional indoor lighting fixtures and systems",
            partnerWielandDesc: "Electrical and automation solutions, focusing on plug & play installation technology",
            partnerLeitnerDesc: "Solar-powered accent outdoor lighting fixtures",
            partnerTwinklyDesc: "Smart decorative lighting"
        },

        // Files Section
        files: {
            title: "DOWNLOADS",
            subtitle: "Download our corporate documents, product catalogs, certifications and informative materials",
            all: "All",
            download: "Download",
            goToSite: "Go to website",
            restricted: "Restricted",
            needDocsTitle: "Need specific documents?",
            needDocsDesc: "Can't find what you're looking for? Contact us and we'll provide you with all the documentation you need.",
            contactUs: "Contact Us",
            // File data
            filePres: "Ellegi Presentation",
            filePresDesc: "Complete Ellegi presentation",
            filePresOutdoor: "Ellegi Presentation - Outdoor Proposals",
            filePresOutdoorDesc: "Ellegi presentation with outdoor proposals",
            fileCollImg: "Ellegi Collaborations - Complete with images",
            fileCollImgDesc: "Ellegi collaborations with images",
            fileCollNoImg: "Ellegi Collaborations - Complete without images",
            fileCollNoImgDesc: "Ellegi collaborations without images",
            fileCatCariboni: "Cariboni Group Catalog",
            fileCatCariboniDesc: "Cariboni products documentation",
            fileCatRidi: "RIDI Italia Catalog",
            fileCatRidiDesc: "RIDI lighting solutions",
            fileCatIntra: "Intra Lighting Catalog",
            fileCatIntraDesc: "Intra Lighting products",
            fileCatLeitner: "Leitner Energy Catalog",
            fileCatLeitnerDesc: "Leitner Energy solutions",
            fileCatTwinkly: "Twinkly Download Area",
            fileCatTwinklyDesc: "Smart decorative lighting",
            fileCatWieland: "Wieland Electric Catalog",
            fileCatWielandDesc: "Wieland Electric solutions"
        },

        // Contacts Section
        contacts: {
            title: "CONTACTS",
            ourTeam: "Our Team",
            headquarters: "Registered Office and CENTRAL AREA",
            phone: "Phone",
            email: "Email",
            contactUsTitle: "Contact Us",
            teamTitle: "Our Team",
            formPrivacyAlert: "You must accept the Privacy Policy to continue.",
            mobLabel: "Mob.",
            // Team member descriptions
            teamClaudioDesc: "Founder of ELLEGI, working in the lighting sector since 1986. He is responsible for and coordinates the agency.",
            teamStefanoDesc: "Operates in the Milan area and coordinates the east and west zones.",
            teamAchilleDesc: "Technical commercial consultant with experience in the management of workspaces.",
            teamGabrieleDesc: "Technical commercial consultant with experience in the sector.",
            teamSilviaDesc: "Marketing & communication manager with experience in the sector.",
            teamMariaTeresaDesc: "Responsible for the administration and financial management of the company.",
            teamStefaniaDesc: "Responsible for order management and customer assistance.",
            // Professions
            prof1: "Retailer", prof2: "Consultant", prof3: "Teacher", prof4: "Electrician",
            prof5: "Journalist", prof6: "Entrepreneur", prof7: "Installer",
            prof8: "Freelancer", prof9: "Lighting Designer",
            prof10: "Designer", prof11: "Project Manager",
            // Request types
            req1: "Catalog request", req2: "Contact request",
            req3: "Distributor info request", req4: "Technical support", req5: "Other",
            formCompany: "Company",
            formName: "Name and Surname",
            formProfession: "Profession",
            formEmail: "Email",
            formPhone: "Phone",
            formAddress: "Address",
            formCity: "City",
            formZip: "ZIP Code",
            formProvince: "Province",
            formCountry: "Country",
            formRequestType: "Request Type",
            formMessage: "Message",
            formPrivacy: "I accept the Privacy Policy and authorize the processing of my personal data in accordance with EU Regulation 2016/679 (GDPR).",
            formSubmit: "Send Request",
            formRequired: "Required fields. Your information will be processed in accordance with privacy regulations.",
            successTitle: "Request Sent Successfully!",
            successMessage: "Thank you for the detailed information provided.",
            successFollowUp: "Our team will contact you within 24 hours to discuss your project.",
            selectProfession: "Select a profession",
            selectCountry: "Select a country",
            selectRequestType: "Select the request type",
            messagePlaceholder: "Enter your message here...",
            companyPlaceholder: "Your company name",
            namePlaceholder: "Your name and surname",
            emailPlaceholder: "Your email (e.g. name@example.com)",
            phonePlaceholder: "Your phone number",
            addressPlaceholder: "Your address",
            cityPlaceholder: "Your city",
            zipPlaceholder: "Postal code",
            provincePlaceholder: "Your province"
        }
    }
};
